import locPin from '../assets/icons/loc_pin.png'
import arrow from '../assets/icons/arrow_white.png'
import gift from '../assets/icons/gift.png'
import { btnOneLight, btnSmallTwo } from '../utils/style';
import { Link } from 'react-router-dom';
import serviceIcons from '../lib/serviceIcons';
import roadsideAssistance from '../lib/roadsideAssistanceList';


function CustomerPreview({font}) {

    return(
        <div className={`flex justify-center text-${font.fontSize}`} style={{ fontFamily: font.fontFamily}}>
            <div className='w-1/3 border p-4 border-gray-300'>
                <div className={"text-xl font-semibold py-1"}>Hello, Kunal!</div>
                <div className='flex gap-2 py-2'>
                    <img src={locPin} width={20} height={20} />
                    <span className={'text-sm'}>{`Royal Windsor Drive, Missisuaga`}</span>
                </div>
                <div className=' py-4 px-4 rounded-xl my-4 bg-gradient-to-r from-[#BACDE0] to-[#E3EBF3]'>
                    <div className={"text-xl font-semibold py-1"}>Choose Your Subscription</div>
                    <div className='flex justify-between'>
                        <div className=''>
                            <div className='py-2 mb-2 text-xs'>Choose a subscription plan to unlock all features of the application.</div>
                            <button className={btnSmallTwo}>
                                <span>View More</span>
                                <span>
                                    <img src={arrow} height={15} width={15}/>
                                </span>
                            </button>
                        </div>
                        <div className='flex items-center'>
                            <img src={gift} width={100} height={100} />
                        </div>
                    </div>
                </div>
                <div className='flex justify-between items-center'>
                    <div className={"text-xl font-semibold py-1"}>Book a Service</div>
                    <Link className='text-customOne underline'>show all</Link>
                </div>
                <div className="grid grid-cols-4 gap-2 px-2 py-4">
                        {
                            serviceIcons.map((icon, ind) => ind < 8 &&
                            <div key={ind} className='flex flex-col justify-between items-center'>
                                <div className='flex justify-center py-2 px-4 border border-customOne bg-customTwo rounded-xl'>
                                    <img alt={'icon-' + ind} src={icon.icon}  />
                                </div>
                                <div className='text-center text-xs '>{icon.short}</div>
                            </div>)
                        }
                </div>
                <div className={"text-xl font-semibold py-1"}>RoadSide Assistance</div>
                <div className='flex gap-4 overflow-x-scroll scroll-x-auto flex-nowrap py-4'>
                    {
                        roadsideAssistance.map((assistance, index) =>
                            <div className='px-4 py-6 rounded-lg bg-customTwo flex-none' key={index}>
                                <div className='p-2 py-4 rounded-lg bg-white flex justify-center'>
                                    <img src={assistance.icon} width={100}/>
                                </div>
                                <div className='py-2 text-md font-semibold'>{assistance.name}</div>
                                <button className={btnOneLight}>
                                    <Link >Book a Service</Link>
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default CustomerPreview;